<template>
    <f7-page name="Feedback">
        <f7-navbar
            title-large="Feedback"
            large
            no-hairline
            large-transparent
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                    style="color: gray"
                />
            </f7-nav-left>
            <f7-nav-title>Feedback</f7-nav-title>
            <f7-nav-right>
                <f7-link
                    href="#"
                    style="padding-right: 10px"
                    @click="closePopup"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                    >
                        <g
                            fill="none"
                            fill-rule="evenodd"
                            stroke="gray"
                            stroke-linecap="square"
                            stroke-width=".75"
                            transform="translate(-2)"
                        >
                            <path d="M3,1 L18,16" />
                            <path
                                d="M4.29545455,0.293103448 L16.7045455,16.7068966"
                                transform="rotate(78 10.5 8.5)"
                            />
                        </g>
                    </svg>
                </f7-link>
            </f7-nav-right>
        </f7-navbar>
        <f7-block>
            What did you think of<br>"{{ course.name }}"?
        </f7-block>
        <f7-list>
            <f7-list-input
                class="textFeedback"
                type="textarea"
                resizable
                placeholder="Your feedback..."
                @input="feedback = $event.target.value"
            />
        </f7-list>
        <f7-block>
            <div class="ansButtons">
                <f7-button
                    fill
                    round
                    color="red"
                    @click="sendFeedback"
                >
                    Send
                </f7-button>
            </div>
        </f7-block>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'topics', 'topicsIndex', 'courses', 'coursesIndex', 'course'],
    data () {
        return {
            currentId: 0,
            slideIndex: 0,
            renderSub: 0,
            mySwiper: null,
            feedback: ''
        };
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        this.getCourse();
    },
    mounted: function () {
        // f7.statusbar.setBackgroundColor('#65749B');
        // f7.statusbar.setTextColor('white');
    },
    methods: {
        closePopup: function () {
            if (this.$f7router.view.main) {
                f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            } else {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            }
            if (!pgap) window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
        },
        sendFeedback: function () {
            this.$http
                .post(`${this.api}/courses/${this.currentId}/feedback`, {
                    feedback: this.feedback
                })
                .then(
                    () => {
                        // this.course = response.body || {};
                        f7.dialog.alert('Thanks!');
                        this.closePopup();
                    },
                    response => {
                        this.closePopup();
                        console.error(response.body.message || 'Unknown error');
                    }
                );
        },
        getCourse: function () {
            this.$http.get(`${this.api}/courses/${this.currentId}`).then(
                response => {
                    this.course = response.body || {};
                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.textFeedback {
    background: #efefef;
    color: black;
    padding: 10px;
    width: 100%;
    text-align: justify;
}
</style>
